
export const EnvironmentsList = {
  '0x9f2ad2c9daab651cb3e704ff3cbbfd31629331b8cf06385e1f0a249e9704d42b' : {
  },
  '0xd28bd4e036df02abce84bc34ede2a63abcefa0567ff2d923f01c24633262c7f8' : {
  },
  '0xcbb8cbc108ced6d2b1038d7694f5279f48b88496a72137fe36523f9d42b42787' : {
  },
}
